const recursiveBuildFormData = (formData: FormData, data: any, parentKey = '') => {
  if (data instanceof File) {
    // Если это File объект, добавляем его напрямую
    formData.append(parentKey, data);
  } else if (Array.isArray(data)) {
    // Если это массив, обрабатываем каждый элемент
    data.forEach((item) => {
      if (item instanceof File) {
        // Для массива файлов используем parentKey без индекса
        formData.append(parentKey, item);
      } else {
        // Для обычных элементов массива используем индекс
        recursiveBuildFormData(formData, item, `${parentKey}[]`);
      }
    });
  } else if (data && typeof data === 'object') {
    // Если это объект, рекурсивно обрабатываем его свойства
    Object.keys(data).forEach((key) => {
      recursiveBuildFormData(
        formData,
        data[key] as Record<string, unknown>,
        parentKey ? `${parentKey}[${key}]` : key,
      );
    });
  } else if (data !== undefined && data !== null) {
    // Для примитивных значений
    formData.append(parentKey, data);
  }
};

export const createFormData = (data: any): FormData => {
  const formData = new FormData();
  recursiveBuildFormData(formData, data);
  return formData;
};
